import {
    forwardRef,
    ForwardRefExoticComponent,
    ReactElement,
    Ref,
    RefAttributes,
    TextareaHTMLAttributes,
} from 'react'
import classNames from 'classnames'

import './Textarea.scss'

interface TextareaProps extends RefAttributes<HTMLTextAreaElement> {
    error?: string;
}

export type HTMLTextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & TextareaProps;

const Textarea: ForwardRefExoticComponent<HTMLTextareaProps> = forwardRef(({
    error = '',
    className = '',
    ...textareaProps
}, ref: Ref<HTMLTextAreaElement>): ReactElement => {
    const textareaClassNames = classNames('textarea-input', {
        'textarea-input--has-error': !! error,
    }, className)

    return (
        <textarea
            {...textareaProps}
            ref={ref}
            className={textareaClassNames}
        />
    )
})

export default Textarea
